import React from "react";

function SurveyResponseError() {
  return <div>Error</div>;
}

export default SurveyResponseError;
